import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import ScrollToTop from '@/components/ScrollToTop';
import CustomerFlow from '@/pages/CustomerFlow';
import KioskDisplay from '@/pages/KioskDisplay';
import AdminDashboard from '@/pages/AdminDashboard';
import FAQPage from '@/pages/FAQPage';
import ServicePage from '@/pages/ServicePage';
import ServicesOverviewPage from '@/pages/ServicesOverviewPage';
import PricingPage from '@/pages/PricingPage';
import ContactPage from '@/pages/ContactPage';
import BlogIndex from '@/pages/BlogIndex';
import BlogPost from '@/pages/BlogPost';
import LocalBusinessPage from '@/pages/LocalBusinessPage';
import NotFoundPage from '@/pages/NotFoundPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<CustomerFlow />} />
        <Route path="/printing-services" element={<ServicesOverviewPage />} />
        <Route path="/printing-prices" element={<PricingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/print-centers" element={<LocalBusinessPage />} />
        <Route path="/print-centers/gurgaon" element={<LocalBusinessPage />} />
        <Route path="/print-centers/delhi" element={<LocalBusinessPage />} />
        <Route path="/locations" element={<LocalBusinessPage />} />
        <Route path="/locations/gurgaon" element={<LocalBusinessPage />} />
        <Route path="/locations/sohna" element={<LocalBusinessPage />} />
        <Route path="/locations/delhi" element={<LocalBusinessPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/kiosk/:kioskId" element={<KioskDisplay />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/:slug" element={<ServicePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
